import { Icon } from '@iconify/react';
import pieChart2Fill from '@iconify/icons-eva/pie-chart-2-fill';
import peopleFill from '@iconify/icons-eva/people-fill';
import shoppingBagFill from '@iconify/icons-eva/shopping-bag-fill';
import fileTextFill from '@iconify/icons-eva/file-text-fill';
import lockFill from '@iconify/icons-eva/lock-fill';
import personAddFill from '@iconify/icons-eva/person-add-fill';
import alertTriangleFill from '@iconify/icons-eva/alert-triangle-fill';
import DashboardIcon from '@mui/icons-material/Dashboard';
import EditNotificationsIcon from '@mui/icons-material/EditNotifications';
import LeaderboardIcon from '@mui/icons-material/Leaderboard';
// ----------------------------------------------------------------------

const getIcon = (name) => <Icon icon={name} width={22} height={22} />;

const sidebarConfig = [
  {
    title: 'nav_dashboard',
    path: '/dashboard/app',
    icon: <DashboardIcon></DashboardIcon> //getIcon(pieChart2Fill)
  },
  // {
  //   title: 'user',
  //   path: '/dashboard/user',
  //   icon: getIcon(peopleFill)
  // },
  {
    title: 'nav_users',
    path: '/dashboard/users',
    icon: getIcon(peopleFill)
  },
  {
    title: 'nav_ranking',
    path: '/dashboard/ranking',
    icon: <LeaderboardIcon></LeaderboardIcon>
  },
  {
    title: 'nav_notifcation',
    path: '/dashboard/notification',
    icon: <EditNotificationsIcon></EditNotificationsIcon>
  },
  // {
  //   title: 'product',
  //   path: '/dashboard/products',
  //   icon: getIcon(shoppingBagFill)
  // },
  // {
  //   title: 'blog',
  //   path: '/dashboard/blog',
  //   icon: getIcon(fileTextFill)
  // },
  // {
  //   title: 'login',
  //   path: '/login',
  //   icon: getIcon(lockFill)
  // },
  // {
  //   title: 'register',
  //   path: '/register',
  //   icon: getIcon(personAddFill)
  // },
  // {
  //   title: 'Not found',
  //   path: '/404',
  //   icon: getIcon(alertTriangleFill)
  // }
];

export default sidebarConfig;
